export default __webpack_public_path__ + "static/media/navbar-regular-orange.c39a1f08.svg";